import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/Journal/config';
import cn from 'classnames';
import s from './Journal.scss';
const JournalViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "journal",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
JournalViewer.displayName = 'JournalViewer';
export default JournalViewer;

//# sourceMappingURL=Journal.js.map